export const nonBreakingSpace = '\xa0';
